import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { BFFComponent } from '@opallabs/api'

type BlockConnector = BFFComponent<'block_connector'>
export const blockConnectorFactory: Factory<BlockConnector> =
  Factory.define<BlockConnector>(
    ({ sequence }) =>
      ({
        id: uuidV4(),
        parent_block: {
          id: uuidV4(),
          name: `Parent Block ${sequence}`,
        },
        category: null,
        view: { id: uuidV4(), name: `Supported View ${sequence}` },
      }) satisfies BlockConnector
  )
